import request from "./request";

const Servico = {
  cadastrarServico: servico => request.post("/orcamentos/servico", servico),
  alterarServico: servico => request.put("/orcamentos/servico", servico),
  excluirServico: id => request.del(`/orcamentos/servico`, { params: { id } }),
  buscarServico: id => request.get(`/orcamentos/servico/${id}`)
};

export default Servico;



// WEBPACK FOOTER //
// ./src/services/servico.js